<template>
  <div class="message-box">
    <div v-if="tempData.status">
      <div class="box1">
        <div class="item">
          <div class="title">Data</div>
          <div class="text" v-text="tempData.date"></div>
        </div>
        <div class="item">
          <div class="title">Time</div>
          <div class="text" v-text="tempData.time"></div>
        </div>
        <div class="item">
          <div class="title">Ref No.</div>
          <div class="text" v-text="tempData.refNo"></div>
        </div>
      </div>
      <div class="message-box">
        <div class="profile-image">
          <img :src="tempData.profileImage" />
        </div>
        <div class="contents">
          <div class="author">
            <span class="name" v-text="tempData.photographerName"></span>
            <span class="date" v-text="tempData.date"></span>
          </div>
          <div class="comment" v-text="tempData.comment"></div>
        </div>
        <!--<div class="buttons">-->
        <!--<button class="upload" >Upload</button>-->
        <!--</div>-->
      </div>
    </div>
    <div class="no-data" v-else>
      <div class="message">There is no Message</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'message-box',
  props: {
    data: {
      default: () => ({
        date: '@/components/2018',
        time: '15:00 - 17:00',
        refNo: '213',
        profileImage: require('@/assets/images/common/temp-profile.jpg'),
        edit: false,
        status: true,
        comment:
          'Hi, thank for the message. How are you doing?\n' +
          'From the apartment to the centre (grand place), it takes more or less 30 minutes. If you tell me better where do you wish to go…',
        photographerName: 'EDDIE PARK'
      }),
      type: Object
    }
  },
  data() {
    return {
      tempData: {}
    }
  },
  created() {
    this.tempData = this.data
  },
  methods: {
    buttonAction(actionName) {
      this.$emit('action', { action: actionName, data: this.tempData })
    }
  }
}
</script>

<style lang="scss" scoped>
.message-box {
  border: 1px solid #c8c8c8;
  .box1 {
    display: none;
    background-color: #f5f5f5;
    /*display: flex;*/
    border-bottom: 1px solid #c8c8c8;
    .item {
      width: 100%;
      height: 80px;
      &:nth-child(1) {
        border-right: 1px solid #c8c8c8;
      }

      &:nth-child(2) {
        border-right: 1px solid #c8c8c8;
      }

      .title {
        margin: 20px 0 0 20px;
        /*border: 1px solid red;*/
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 1px;
      }

      .text {
        margin: 10px 0 0 20px;
        font-size: 16px;
        font-weight: 300;
        letter-spacing: 1px;
      }
    }
  }
  .message-box {
    display: flex;
    justify-content: space-between;
    background-color: #f6f6f6;
    .profile-image {
      width: 131px;
      height: 131px;
      position: relative;
      img {
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 100px;
        height: 100px;
      }
    }
    .contents {
      width: 90%;
      margin: 18px 0 18px 0;
      .author .name {
        font-weight: 600;
      }

      .comment {
        margin: 10px 0 0 0;
        width: 700px;
        height: 71px;
        letter-spacing: 1px;
        line-height: 23px;
        /*border: 1px solid red;*/
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .buttons {
      width: 200px;
      /*border: 1px dotted green;*/
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      button {
        width: 150px;
        height: 50px;
        font-size: 14px;
        font-weight: 300;
        letter-spacing: 1px;
        cursor: pointer;
        outline: none;
      }
      .upload {
        border: 0;
        background-color: #000bff;
        color: white;
      }
    }
  }
  .no-data {
    height: 200px;
    position: relative;
    .message {
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 200px;
      text-align: center;
      height: 20px;
    }
    background-color: #f5f5f5;
  }
}
</style>
